import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default Box;
